import './src/styles/icons.css';

window.onUsersnapCXLoad = function(api) {
  api.init();
  window.upskillistUserSnapApi = api;
};
